export const CONSOLE_USERNAME_RULE_MESSAGE = '用户名需以字母开头，仅含字母和数字，长度 3-10 位'

export function isValidConsoleUsername(value: string): boolean {
  return /^[A-Za-z][A-Za-z0-9]{2,9}$/.test(value)
}
